import React, { useEffect, useMemo, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-routing-machine';
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

const redIcon = new L.icon({
  iconUrl: require('../icons/red-icon.png'),
  iconSize: [30, 30]
});

const blueIcon = new L.icon({
  iconUrl: require('../icons/blue-icon.png'),
  iconSize: [30, 30]
});

const CTMap = React.memo(({
  zoom,
  location1,
  location2,
  origins,
  destinations
}) => {
    // Reference to store the map instance to avoid re-creating it
  const mapRef = useRef(null);
  //TODO: define few bounds like california, newyork, US and Canada.
  let position1 = [36.778259, -119.417931];
  let position2 = [43.651070, -79.347015];
  if(location1 && location1[0] && location1[0].length === 2) {
    position1 = location1[0];
  }
  if(location2 && location2[0] && location2[0].length === 2) {
    position2 = location2[0];
  }
  const bounds = useMemo(() => L.latLngBounds([position1, position2]));


  useEffect(() => {
    // Initialize the map only once
    if (!mapRef.current) {
      mapRef.current = true;  // Mark the map as initialized
    }    
  },[]);

  function FitBounds({
    origin,
    destination,
  }) {
    const map = useMap();
    map.fitBounds([origin, destination], { padding: [50, 50] });
    return null;
  };
  
  function RoutingControl({ origin, destination }) {
    const map = useMap();
    React.useEffect(() => {
      if (!map || !origin || !destination) return;
    //@ts-ignore
      const routingControl = L.Routing.control({
        waypoints: [
          L.latLng(origin[0], origin[1]),
          L.latLng(destination[0], destination[1])
        ],
        routeWhileDragging: false,
        show: false,
        addWaypoints: false,
        draggableWaypoints: false,
        createMarker: () => null, // hide default markers
      }).addTo(map);

      return () => {
        if(map & routingControl) {
          try {
            map.removeControl(routingControl);
          } catch(err) {
            console.warn('Routing Control already removed');
          }
        }
      };
    }, [map, origin, destination]);

    return null;
  };  
  return (
    <MapContainer
      zoom={zoom}
      bounds={bounds}
      scrollWheelZoom={false}
      whenReady={({target }) => {
        if(!mapRef.current) {
          mapRef.current = target;
        }
      }}
      style={{ width: '100%', height: '100%' }}
    >
      <TileLayer      
        attribution='<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>'
        url="https://api.maptiler.com/maps/basic/256/{z}/{x}/{y}.png?key=sbMWbfkbgU0IxQhM8xu8"
      />
      {origins.map((loc, idx) =>
        loc.address && loc.address.geo &&
          <Marker position={loc.address.geo} key={idx} icon={redIcon}>
            <Popup>{`Origin: ${loc.name.value}`}</Popup>
          </Marker>
      )}
      {destinations.map((loc, idx) =>
        loc.address && loc.address.geo &&
          <Marker position={loc.address.geo} key={idx} icon={blueIcon}>
            <Popup>{`Destination: ${loc.name.value}`}</Popup>
          </Marker>
      )}
      <FitBounds origin={position1} destination={position2} />
      <RoutingControl origin={position1} destination={position2} />      
    </MapContainer>
  );
});
export default CTMap;